// extracted by mini-css-extract-plugin
module.exports = {"modal":"SubgroupEdit_modal__3CBQF"};